import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Button, ButtonGroup } from "react-bootstrap";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { closeCustomModal, openCustomModal } from "components/custom/modals";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import {
    fetchJobs,
    deleteJob,
    clearJobs
} from "api/menu/master-files/job-maintenance/actions";
import ManageTraitsModal from "./manage-traits-modal";

// import JobEditModal from "components/menu/master-files/job-maintenance/create-edit-modal";
const JobEditModal = React.lazy(() =>
    import("components/menu/master-files/job-maintenance/create-edit-modal"));

class JobsList extends React.Component {
    constructor(props) {
        super(props);

        this.modalOpen = this.modalOpen.bind(this);
        this.handleTraitsModal = this.handleTraitsModal.bind(this);
    }

    componentDidMount () {
        this.props.fetchJobs();
    }

    componentWillUnmount () {
        this.props.clearJobs();
    }

    modalOpen = (jobId = false) => {
        const modalTitle = jobId !== false ? "Update" : "Create";

        const modalObj = {
            id: `job-${jobId}`,
            modalSettings: {
                size: "lg"
            },
            header: `${modalTitle} Job`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <JobEditModal
                        jobId={jobId}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleTraitsModal = (jobId) => {
        const modalObj = {
            modalSettings: {
                size: "lg"
            },
            header: "Traits Management",
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ManageTraitsModal
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        jobId={jobId}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    }

    delete = (jobId, name) => {
        this.props.deleteJob(jobId, name, () => this.props.fetchJobs());
    };

    render () {
        const {
            jobs,
            loading
        } = this.props;

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Job Number",
                accessor: "jobNumber",
                id: "jobNumber",
            },
            {
                Header: "Description",
                accessor: "description",
                id: "description",
            },
            {
                Header: "Retailer",
                accessor: "retailerId",
                id: "retailerId",
                Cell: ({ original }) => original.retailer,
                Filter: ({ filter, onChange }) => {
                    const retailers = {};
                    jobs.forEach((value) => {
                        retailers[value.retailerId] = value.retailer;
                    });
                    return (
                        <ReactTableFilterSelect
                            currentValue={filter ? filter.value : ""}
                            onChange={value => onChange(value)}
                            style={{
                                width: "100%",
                                height: "100%"
                            }}
                            optionsObject={retailers}
                            showAllOption={true}
                        />
                    );
                    /* return (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%", height: "100%" }}
                            value={filter ? filter.value : ""}
                        >
                            <option value="">Show All</option>
                            {Object.keys(retailers).map((key) => (
                                <option key={key} value={retailers[key].value}>
                                    {retailers[key].label}
                                </option>
                            ))}
                        </select>
                    ); */
                }
            },
            {
                Header: "Active?",
                id: "isInactive",
                accessor: original => (original.isInactive ? "NO" : "YES"),
                Cell: ({ original }) => (original.isInactive ? "NO" : "YES"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            {
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Button variant="warning" size="sm" onClick={() => this.handleTraitsModal(original.id)}>
                            <FontAwesomeIcon icon="asterisk" title="Traits" />
                        </Button>
                        <Button size="sm" onClick={() => this.modalOpen(original.id)}>
                            <FontAwesomeIcon icon="pen" title="Update" />
                        </Button>
                        <Popconfirm
                            title={`Delete "${original.jobNumber}"?`}
                            onConfirm={() => this.delete(original.id, original.jobNumber)}
                            placement="bottomRight"
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <Button variant="danger" size="sm">
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </Popconfirm>
                    </ButtonGroup>
                ),
                filterable: false,
                width: 100
            },
        ];

        return (
            <div className="dashboard">
                <h3 className="mb-4">
                    Job Maintenance
                </h3>

                <ReactTable
                    data={jobs}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    defaultSorted={[
                        {
                            id: "jobNumber",
                            desc: false
                        }
                    ]}
                    defaultFiltered={[
                        {
                            id: "isInactive",
                            value: "YES"
                        }
                    ]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 200px)",
                    }}
                />

                <div className="mt-4 mb-4 text-right">
                    <Button className="ml-2" variant="primary" onClick={() => this.modalOpen()}>
                        Add New Job
                    </Button>
                </div>
            </div>
        );
    }
}

JobsList.propTypes = {
    fetchJobs: PropTypes.func.isRequired,
    deleteJob: PropTypes.func.isRequired,
    clearJobs: PropTypes.func.isRequired,

    jobs: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    jobs: state.jobs.jobs,
    loading: state.jobs.loading
});

const mapStateToDispatch = dispatch => ({
    fetchJobs: bindActionCreators(fetchJobs, dispatch),
    deleteJob: bindActionCreators(deleteJob, dispatch),
    clearJobs: bindActionCreators(clearJobs, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(JobsList);
